import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * The top of every admin dashboard page, in the brand flow's look: title,
 * one-line description, actions on the right. Styles: ../admin-theme.scss.
 */
export function AdminPageHead({ title, subtitle, actions }: {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
}) {
    return (
        <header className="brd-page-head brd-admin-head">
            <div className="brd-page-head__text">
                <h1 className="brd-page-head__title">{title}</h1>
                {!!subtitle && <p className="brd-page-head__sub">{subtitle}</p>}
            </div>
            {!!actions && <div className="brd-admin-head__actions">{actions}</div>}
        </header>
    );
}

type AdminTab = { label: React.ReactNode; icon?: React.ReactNode } & (
    | { to: string; value?: never }
    | { value: string; to?: never }
);

/**
 * A page's own tabs (Influencers / Brands, Campaign Details / Feedbacks …):
 * links when each tab is its own URL (`to`), buttons when the page switches
 * them itself (`value` + `current` + `onChange`).
 */
export function AdminTabs({ tabs, current, onChange }: {
    tabs: AdminTab[];
    current?: string;
    onChange?: (value: string) => void;
}) {
    return (
        <div className="brd-tabs brd-admin-tabs" role="tablist">
            {tabs.map((t, i) =>
                t.to ? (
                    <NavLink key={i} to={t.to} end className={({ isActive }) => `brd-tabs__tab${isActive ? ' brd-tabs__tab--on' : ''}`}>
                        {t.icon} {t.label}
                    </NavLink>
                ) : (
                    <button key={i} type="button" role="tab" aria-selected={current === t.value}
                        className={`brd-tabs__tab${current === t.value ? ' brd-tabs__tab--on' : ''}`}
                        onClick={() => onChange?.(t.value as string)}>
                        {t.icon} {t.label}
                    </button>
                )
            )}
        </div>
    );
}
